export const validatePaymentDocumentDraft = (draft = {}) => {
  const nextErrors = {};
  const type = String(draft.type || '').trim();
  const isTransfer = /transfer/i.test(type);
  const isAch = isTransfer && Boolean(draft.isAch);
  const showReference = !/efectivo/i.test(type);
  const referenceRequired = showReference && !isAch;

  if (!type) nextErrors.type = 'Selecciona un tipo';
  if (!(Number(draft.amount) > 0)) {
    nextErrors.amount = 'Monto invalido (debe ser > 0)';
  }
  if (!draft.date || Number.isNaN(new Date(draft.date).getTime())) {
    nextErrors.date = 'Fecha requerida';
  }
  if (showReference) {
    if (referenceRequired && !String(draft.reference || '').trim()) {
      nextErrors.reference = 'Referencia requerida';
    }
    if (!draft.bankAccount) nextErrors.bankAccount = 'Cuenta bancaria requerida';
  }
  if (isAch && !(draft.files || []).length) {
    nextErrors.files = 'El comprobante es obligatorio para transferencias ACH';
  }
  return nextErrors;
};
